<template>
  <v-card class="pa-3">
    <div class="cardOverflow">
      <v-card-title>
        <v-layout row wrap justify-space-between>
          <v-flex grow>
              <p style="font-size: 18px;margin: 0;">{{item.name[$lang.current_lang] ? item.name[$lang.current_lang] : item.name.en}}</p>
          </v-flex>
          <v-flex shrink>
            <v-layout row wrap class="quantity-value">
              <v-flex shrink pr-2 pt-1>
                <span>{{$lang.labels.quantity}}:</span>
              </v-flex>
              <v-flex class="quantity-wrap">
                <v-btn dark small color="primary ma-0 my-btn" @click="changeQty(quantity - 1)">
                  <v-icon dark>remove</v-icon>
                </v-btn>
                <span class="quantity text-xs-center" style="min-width: 24px; width: 24px">{{ quantity }}</span>
                <v-btn name="add" dark small color="accent ma-0 my-btn" @click="changeQty(quantity + 1)">
                  <v-icon dark>add</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 v-if="item.desc">
            <span class="desc" :style="goDark ? 'color: white' : ''">{{item.desc[$lang.current_lang] ? item.desc[$lang.current_lang] : item.desc.en}}</span>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-layout row wrap class="px-4">
        <div class="order-section-wrap" v-if="item.sizes.length > 1">
          <div class="mt-1">
            {{$lang.labels.size}}:
          </div>
          <v-flex ml-2>
            <v-radio-group id="size" v-model="selectedSize" @change="calculatePrice" class="pt-0">
              <v-radio v-for="(size, index) in item.sizes" :key="index" :label="`${size.name[$lang.current_lang] ? size.name[$lang.current_lang] : size.name.en} ${company ? company.currencySymbol : ''}${size.price.toFixed(2)}`" :value="index"></v-radio>
            </v-radio-group>
          </v-flex>
        </div>
        <div class="order-section-wrap pl-0 pl-sm-4" v-if="item.variants.length > 1">
          <div class="mt-1">
            {{$lang.labels.variant}}:
          </div>
          <v-flex ml-2>
            <v-radio-group id="variant" v-model="selectedVariant" @change="calculatePrice" class="pt-0">
              <v-radio v-for="(variant, index) in item.variants" :key="index" :label="`${variant.name[$lang.current_lang] ? variant.name[$lang.current_lang] : variant.name.en} ${company ? company.currencySymbol : ''}${variant.price.toFixed(2)}`" :value="index"></v-radio>
            </v-radio-group>
          </v-flex>
        </div>
        <div class="order-section-wrap pl-0 pl-sm-4" v-if="item.styles.length > 1">
          <div class="mt-1">
            {{$lang.labels.style}}:
          </div>
          <v-flex ml-2>
            <v-radio-group id="style" v-model="selectedStyle" @change="calculatePrice" class="pt-0">
              <v-radio v-for="(style, index) in item.styles" :key="index" :label="`${style.name[$lang.current_lang] ? style.name[$lang.current_lang] : style.name.en}`" :value="index"></v-radio>
            </v-radio-group>
          </v-flex>
        </div>
        <div class="order-section-wrap">
          <div class="mt-1" v-if="options.length > 0">
            {{$lang.labels.options}}:
          </div>
          <v-layout column class="options">
            <v-flex xs12 class="single-option" v-for="(option, index) in options" :key="index">
              <v-layout row wrap ml-2>
                <v-checkbox
                  hide-details
                  :label="`${option.name[$lang.current_lang] ? option.name[$lang.current_lang] : option.name.en} ${company ? company.currencySymbol : ''}${option.price.toFixed(2)}`"
                  v-model="option.selected"
                  @change="calculatePrice"
                />
                <v-flex class="quantity-wrap" v-if="option.selected">
                  <v-btn dark small color="primary ma-0 my-btn" @click="changeOptionQty(option, option.quantity - 1)">
                    <v-icon dark>remove</v-icon>
                  </v-btn>
                  <span class="quantity text-xs-center">{{ option.quantity }}</span>
                  <v-btn name="add" dark small color="accent ma-0 my-btn" @click="changeOptionQty(option, option.quantity + 1)">
                    <v-icon dark>add</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </div>
      </v-layout>
      <v-layout row wrap v-if="item.allergens && item.allergens.length > 0" class="px-3 pt-3 pb-4">
        <v-flex xs12>
          <span class="desc" :style="goDark ? 'color: white' : ''">{{$lang.labels.allergens}}: <span v-for="(allergen, i) in item.allergens">{{formatAllergen(allergen)}}{{i === item.allergens.length-1 ? '' : ', '}}</span></span>
        </v-flex>
      </v-layout>
    </div>
    <footer class="modal-footer pb-4" :style="`background-color: ${goDark ? '#212121' : ''}`">
      <v-alert
        color="error"
        class="err mx-3"
        icon="warning"
        value="true"
        v-if="err">{{err}}
      </v-alert>
      <v-layout row justify-space-between align-center class="px-3 pt-3">
        <v-btn
          outline
          color="primary"
          @click.stop="$emit('close')">{{$lang.actions.cancel}}</v-btn>
        <div class="d-inline-flex">
          <p v-if="total" style="margin: 0; padding-top: 15px">{{$lang.labels.price}}: {{company ? company.currencySymbol : ''}}{{total}}</p>
          <v-btn type="submit" color="primary" dark @click="toCart()">{{$lang.actions.add}}</v-btn>
        </div>
      </v-layout>
    </footer>
    <v-dialog scrollable :fullscreen="width < 768" v-model="allergensDialog" v-if="allergensDialog"
              max-width="200px">
      <Allergens @close="closeDialog()" :allergens="allergens" :catalogAllergens="catalog.allergens" />
    </v-dialog>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex';
  import Allergens from '@/components/webshop/modals/Allergens';

  export default {
    components: {
      Allergens,
    },
    props: ['item'],
    data: () => ({
      selectedStyle: null,
      selectedSize: null,
      selectedVariant: null,
      quantity: 1,
      comment: '',
      options: [],
      err: '',
      total: '',
      allergensDialog: false,
      allergens: [],
    }),
    computed: mapGetters({
      company: 'company',
      width: 'width',
      catalog: 'catalog',
      goDark: 'goDark',
    }),
    methods: {
      openAllergens(allergens) {
        this.allergens = allergens;
        this.allergensDialog = true;
      },
      formatAllergen(id) {
        // eslint-disable-next-line max-len
        return this.catalog.allergens.filter(x => x.allergenId === id)[0].name[this.$route.lang] || this.catalog.allergens.filter(x => x.allergenId === id)[0].name[this.company.defaultLanguage];
      },
      changeOptionQty(option, quantity) {
        if (quantity < 1) return;
        this.$set(option, 'quantity', quantity);
        this.calculatePrice();
      },
      changeQty(q) {
        if (q === 0) return;
        this.quantity = q;
        this.calculatePrice();
      },
      calculatePriceOffline(item) {
        this.total = parseFloat(this.$store.state.calculatePrice(
          item.selectedSize,
          item.selectedVariants,
          item.selectedOptions,
          item.quantity,
          item.quantityOfIncludedOptions,
        )).toFixed(2);
      },
      calculatePrice() {
        if (
          this.selectedStyle === null ||
          this.selectedVariant === null ||
          this.selectedSize === null
        ) return;
        const options = this.options
          .filter(current => current.selected)
          .map((current) => {
            const option = Object.assign({}, current);
            delete option.selected;
            option.quantity = !option.quantity ? 1 : option.quantity;
            return option;
          });
        const item = {
          itemId: 0,
          catalogItemId: this.item.itemId,
          quantity: this.quantity,
          comment: this.comment,
          abbr: this.item.abbr,
          name: this.item.name,
          desc: this.item.desc,
          vatRate: this.item.vatRate,
          sizes: this.item.sizes,
          variants: this.item.variants,
          options: this.item.options,
          styles: this.item.styles,
          quantityOfIncludedOptions: this.item.quantityOfIncludedOptions,
        };
        item.selectedStyle = this.item.styles[this.selectedStyle];
        item.selectedOptions = options || null;
        item.selectedVariants = this.item.variants[this.selectedVariant] || null;
        item.selectedSize = this.item.sizes[this.selectedSize];

        this.$webHelper.post('order/calculatetotalamount', {
          items: [item],
          deliveryCharges: 0,
          distanceInMiles: 0,
        }, this.$router)
          .then((res) => {
            if (!res.success) {
              this.warn = this.$lang.errors.calculateServer;
              this.calculatePriceOffline(item);
              return;
            }
            this.total = res.body.itemsTotalAmount;
          });
      },
      toCart() {
        this.err = '';
        const options = this.options
          .filter(current => current.selected)
          .map((current) => {
            const option = Object.assign({}, current);
            delete option.selected;
            option.quantity = !option.quantity ? 1 : option.quantity;
            return option;
          });
        if (this.selectedStyle === null) {
          this.err = this.$lang.errors.mustSelectStyle;
          return;
        }

        if (this.selectedSize === null) {
          this.err = this.$lang.errors.mustSelectSize;
          return;
        }

        if (this.item.variants && this.item.variants.length !== 0) {
          if (this.selectedVariant === null) {
            this.err = this.$lang.errors.mustSelectVariant;
            return;
          }
        }
        const modal = {
          itemId: null,
          catalogItemId: this.item.itemId,
          quantity: this.quantity,
          comment: this.comment,
          abbr: this.item.abbr,
          name: this.item.name,
          desc: this.item.desc,
          vatRate: this.item.vatRate,
          sizes: this.item.sizes,
          variants: this.item.variants,
          options: this.item.options,
          styles: this.item.styles,
          quantityOfIncludedOptions: this.item.quantityOfIncludedOptions,
        };
        modal.allergens =
            this.item.allergens && this.item.allergens.length > 0 ? this.item.allergens : [];
        modal.selectedStyle = this.item.styles[this.selectedStyle];
        modal.selectedOptions = options || null;
        modal.selectedVariants = this.item.variants[this.selectedVariant] || null;
        modal.selectedSize = this.item.sizes[this.selectedSize];
        const event = this.isEdit ? 'edit' : 'submit';
        this.$emit(event, modal);
        this.$emit('close');
      },
      closeDialog() {
        this.allergens = [];
        this.allergensDialog = false;
      },
    },
    created() {
      this.quantity = this.item.quantity || 1;
      if (this.item.options) {
        this.item.options.forEach((option) => {
          this.options.push(Object.assign({}, option,
            { selected: option.isDefault || false, quantity: 1 }));
        });
      }
      if (this.item.styles && this.item.styles.length === 1) {
        this.selectedStyle = 0;
      } else if (this.item.styles && this.item.styles.length > 1) {
        let isStyleFound = false;
        this.item.styles.forEach((style, index) => {
          if (style.isDefault && !isStyleFound) {
            isStyleFound = true;
            this.selectedStyle = index;
          }
        });
      }
      if (this.item.sizes && this.item.sizes.length === 1) {
        this.selectedSize = 0;
      } else if (this.item.sizes && this.item.sizes.length > 1) {
        let isSizeFound = false;
        this.item.sizes.forEach((size, index) => {
          if (size.isDefault && !isSizeFound) {
            isSizeFound = true;
            this.selectedSize = index;
          }
        });
      }
      if (this.item.variants && this.item.variants.length === 1) {
        this.selectedVariant = 0;
      } else if (this.item.variants && this.item.variants.length > 1) {
        let isVariantFound = false;
        this.item.variants.forEach((variant, index) => {
          if (variant.isDefault && !isVariantFound) {
            isVariantFound = true;
            this.selectedVariant = index;
          }
        });
      }
      this.calculatePrice();
    },
  };
</script>

<style lang="scss">
  .order-section-wrap {
    width: 33%;
    @media only screen and (max-width: 968px) {
      width: 50%;
    }
  }
  .options {
    width: 100%;
    .input-group {
      min-width: 140px;
      flex: none;
      width: fit-content;
      padding: 0 32px !important;
      .input-group__details {
        display: none !important;
      }
      label {
        position: relative !important;
        left: 0px !important;
        max-width: 220px !important;
        width: fit-content;
        overflow: hidden;
      }
      .input-group__input {
        position: absolute !important;
        left: 0 !important;
        top: 0;
        width: 32px !important;
        flex: 0;
      }
      &--selection-controls {
        display: inline;
      }
    }
    .single-option {
      flex: 0 !important;
      padding-right: 10px;
    }
    .quantity-wrap {
      flex: 0 1 auto;
      margin: 2px 10px 0 0;
      min-width: 80px;
    }
    .quantity {
      display: inline-block;
      width: 24px;
      height: 24px;
    }
  }
  .quantity-value {
    .quantity-wrap {
      flex: 0 1 auto;
      margin: 2px 10px 0 0;
      min-width: 80px;
    }
    .quantity {
      display: inline-block;
      width: 24px;
      height: 24px;
    }
  }
  @media only screen and (max-width: 600px) {
    .order-section-wrap {
      width: 100%;
    }
  }
  .modal-footer {
    -webkit-box-shadow: 0px -2px 14px -8px rgba(0,0,0,0.75);
    -moz-box-shadow: 0px -2px 14px -8px rgba(0,0,0,0.75);
    box-shadow: 0px -2px 14px -8px rgba(0,0,0,0.75);
    @media only screen and (max-width: 768px) {
      position: fixed;
    }
    @media only screen and (min-width: 769px) {
      position: absolute;
    }
    display: block !important;
    bottom: 0;
    z-index: 20;
    width: 100%;
    left: 0;
    background: #fff;
  }
  .v-card {
    /*max-height: 90vh;*/
    height: auto;
    overflow: hidden;
  }
  .cardOverflow {
    height: 100%;
    max-height: 90vh;
    overflow-y: auto;
    @media only screen and (min-width: 769px) {
      padding-bottom: 88px;
    }
    @media only screen and (max-width: 768px) {
      max-height: 100vh;
      padding-bottom: 200px;
    }
  }
  .pointerCursor {
    cursor: pointer;
  }
  .orangeTheme {
    color: #efa546 !important;
  }
  .desc {
    min-width: 1px;
    color: rgba(0, 0, 0, 0.5);
  }
</style>



// WEBPACK FOOTER //
// src/components/webshop/modals/Order.vue